import { Component, OnDestroy, OnInit } from '@angular/core';
import { BellNotficationService } from '../../services/bell-notification.service';
import { EmployeeInfoService } from '../../services/employee-info.service';
import { UtilityService } from '../../services/utility.service';
import moment from 'moment';

@Component({
  selector: 'bell-notification',
  templateUrl: './bell-notification.component.html',
  styleUrls: ['./bell-notification.component.css'],
})
export class BellNotificationComponent implements OnInit, OnDestroy {
  employeeInfo: any;
  dateFormat: string;
  isMobile = false;

  constructor(
    private employeeInfoService: EmployeeInfoService,
    private utilityService: UtilityService,
    public bellNotficationService: BellNotficationService
  ) {
    this.dateFormat = utilityService.getDateFormat();
    this.isMobile = utilityService.isMobileMode();
    this.employeeInfo = employeeInfoService.getEmployeeInfo();
  }

  public ngOnInit(): void {}

  public ngOnDestroy(): void {
    this.bellNotficationService.onDestroy();
  }

  formatDateTime(dateTime: any) {
    return moment(dateTime).format(this.dateFormat.toUpperCase() + ' h:mm:ss a');
  }

  onclickBellNotificationDropdown() {
    this.bellNotficationService.hasNewNotification = false;
  }

  downloadBellNotification(event: any, bellNotificationId: number, filePath: string, status: number) {
    if (status != 1) {
      // prevent dropdown from closing
      event.stopPropagation();
      return;
    }

    if (this.bellNotficationService.bellNotifications.length > 1) {
      // prevent dropdown from closing
      event.stopPropagation();
    }

    this.bellNotficationService.downloadBellNotification(this.employeeInfo.UserKeyID, bellNotificationId, filePath);
  }

  dismissBellNotification(event: any, bellNotificationId: number) {
    if (this.bellNotficationService.bellNotifications.length > 1) {
      // prevent dropdown from closing
      event.stopPropagation();
    }

    this.bellNotficationService.dismissBellNotification(this.employeeInfo.UserKeyID, bellNotificationId).then((response: any) => {
      if (response.success) {
        this.bellNotficationService.removeBellNotification(bellNotificationId);
      } else {
        // do something?
      }
    });
  }
}
